import { deserialize } from 'cerialize'

export class SmsLimitModel {
	@deserialize public minute_limit?: number
	@deserialize public hour_limit?: number
	@deserialize public day_limit?: number
	@deserialize public month_limit?: number
	@deserialize public send_real_sms?: boolean
}
